
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export const EnvironmentAction = () => {
  return <section className="py-6 md:py-10 bg-white relative overflow-hidden">
      <div className="container relative z-10">
        <div className="bg-[#F7F7F7] rounded-2xl p-6 md:p-12 max-w-[1200px] mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6 md:gap-8">
            <div className="w-full md:w-1/2">
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6 text-dark leading-tight">L'indice de la Citoyenneté Française</h2>
              <p className="text-lg sm:text-xl mb-6 md:mb-8 max-w-2xl text-dark/80">
                Rejoignez notre association et participez à la défense des droits des citoyens.
              </p>
              <div className="w-full sm:w-auto">
                <Link to="/indice-citoyennete" className="w-full sm:w-auto inline-flex items-center justify-center bg-[#39CCFF] hover:bg-[#39CCFF]/90 text-white px-6 py-3 rounded-lg font-medium transition-colors">
                  Découvrer ICF 2025
                  <ArrowRight className="ml-2" size={20} />
                </Link>
              </div>
            </div>
            <div className="w-full md:w-1/2 flex justify-center">
              <div className="relative w-full flex justify-center">
                <img src="/lovable-uploads/f7e71a8f-2d00-475e-91a2-9ecd3a16c168.png" alt="Action environnementale" className="rounded-2xl h-auto max-h-[300px] md:max-h-[350px] object-contain shadow-xl transform hover:scale-[1.02] transition-all duration-300" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
